import { render, staticRenderFns } from "./GlobalLoader.vue?vue&type=template&id=5e6982aa"
var script = {}
import style0 from "./GlobalLoader.vue?vue&type=style&index=0&id=5e6982aa&prod&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports